import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from '../../util/Api';
import axios from 'util/Api';
import {fetchError, fetchStart, fetchSuccess} from './Common';
import {
  CLEAR_PROPS_DATA,
  CREATE_SUB_ASSET_TRANSFER_SUCCESS,
  FETCH_ASSET_WITH_PARENT_KEY_SUCCESS,
  FETCH_CHILD_ASSET_BY_ID_SUCCESS,
  FETCH_SUB_ASSET_TRANSFER_SUCCESS,
  GET_JOB_CARD_FROM_ASSET,
  GET_JOB_CARD_FROM_ASSET_START,
  GET_JOB_CARD_FROM_ASSET_STOP,
  GET_SUB_ASSET_TRANSFER_SUCCESS,
  SAVE_SUB_ASSET_TRANSFER_QUERY,
} from "../../constants/ActionTypes";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_SUB_ASSET_TRANSFER_SUCCESS,
    data,
    count,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SUB_ASSET_TRANSFER_QUERY,
    query,
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_SUB_ASSET_TRANSFER_SUCCESS,
    data,
  };
};

export const clearProps = () => {
  return {
    type: CLEAR_PROPS_DATA,
  };
}

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_SUB_ASSET_TRANSFER_SUCCESS,
    data,
  };
};

export const fetchAssetsListSuccess = (data) => {
  return {
    type: FETCH_CHILD_ASSET_BY_ID_SUCCESS,
    data,
  };
};

export const fetchToAssetsListSuccess = (data) => {
  return {
    type: FETCH_ASSET_WITH_PARENT_KEY_SUCCESS,
    data,
  };
};


export const fetchAssetWithParentKeySuccess = ({data}) => {
  return {
    type: FETCH_ASSET_WITH_PARENT_KEY_SUCCESS,
    data,
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {subAssetTransfer} = store.getState();
      const {query} = subAssetTransfer;
      const response = await axios.get(`/sub-asset-transfer?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {subAssetTransfer} = store.getState();
      const {query} = subAssetTransfer;
      const response = await axios.get(`/sub-asset-transfer/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      let formData = new FormData();

      const documentData = [];
      payload.documents && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data);
      });

      formData.append('documentData', JSON.stringify(documentData));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }

        if(key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy' || key === 'readings' || key === 'assets') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });

      const response = await axios.post(`/sub-asset-transfer`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push('/sub-asset-transfer');
      dispatch(getResource());
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {

      let formData = new FormData();

      const documentData = [];
      const documentIds = [];
      payload.documents.map((item, index) => {
        if(!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data);
        } else {
          documentIds.push(item._id);
        }
      });

      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));

      Object.keys(payload).forEach(key => {
        if(key === 'documents') {
          return;
        }

        if(key === 'from' || key === 'to' || key === 'approvedBy' || key === 'preparedBy') {
          formData.append(key, JSON.stringify(payload[key]));
          return;
        }

        formData.append(key, payload[key]);
      });


      await axios.put(`/sub-asset-transfer/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      history.push('/sub-asset-transfer');
      dispatch(getResource());
    } catch (error) {
      console.log('Error****:', error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/sub-asset-transfer/${id}`);
      dispatch(fetchSuccess());

      if(response.data) {
        let assetDetail = [];
        assetDetail[0] = response.data.asset ? response.data.asset : {};
        response.data.assetDetail = assetDetail;
        // console.log(response.data);
      }
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/sub-asset-transfer/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const isParent = async (id) => {
  try {
    const flag = await axios.get(`/sub-asset-transfer/isParent/${id}`);
    return flag.data;
  } catch (error) {
    console.log('Error****:', error.response.data.message);
  }
};

export const fetchAssetsList = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/sub-asset-transfer/getAssetsList`, payload);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsListSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};

export const fetchToAssetsList = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/sub-asset-transfer/getToAssetsList`, payload);
      // console.log(response.data);
      dispatch(fetchSuccess());
      dispatch(fetchToAssetsListSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};

export const fetchAssetWithParentKey = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart());

    try {
      const response = await axios.post(`/sub-asset-transfer/getAssetWithParentKey`, payload);
      dispatch(fetchSuccess());
      dispatch(fetchAssetWithParentKeySuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};

export const fetchJobCardsFromAsset = (assetId, direction = '') => {
  return async (dispatch) => {
    dispatch(getJobCardsFromAssetProcess(true));
    try {
      const response = await axios.get(`/job-card/by-asset/${assetId}`);

      dispatch(getJobCardsFromAssetProcess(false));
      dispatch(fetchJobCardsFromAssetSuccess({data: response.data, direction}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  }
};

export const fetchJobCardsFromAssetSuccess = ({data, direction}) => {
  return {
    type: GET_JOB_CARD_FROM_ASSET,
    data,
    direction,
  };
};

export const getJobCardsFromAssetProcess = (isStart) => {
  return {
    type: isStart ? GET_JOB_CARD_FROM_ASSET_START : GET_JOB_CARD_FROM_ASSET_STOP,
  };
};






